var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_vm._m(0),_c('hr'),_c('section',_vm._l((_vm.$store.state.friends),function(user){return _c('FriendComponent',{key:user.id,attrs:{"user":user}})}),1),_c('p',[_vm._v("end of chirpers")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h1',[_vm._v(" my chirpers ")])])
}]

export { render, staticRenderFns }